module.exports = ".txtName {\n  padding-top: 6px; }\n\n.mat-form-field {\n  width: 200px; }\n"